import ValidationModal from './ValidationModal'

export default {
  validationModal: ValidationModal
}
